import { Component } from '@angular/core';

interface PricingModel {
  icon: string;
  title: string;
  description: string;
  features: string[];
  ctaText: string;
}

@Component({
  selector: 'app-pricing-models',
  templateUrl: './pricing-models.component.html',
  styleUrls: ['./pricing-models.component.scss'],
  standalone: false
})
export class PricingModelsComponent {
  models: PricingModel[] = [
    {
      icon: 'bi bi-speedometer2',
      title: 'Pago por Uso',
      description: 'Ideal para clientes con demandas variables. Se cobra según el número de interacciones o tokens consumidos.',
      features: [
        'Sin cuota mensual fija',
        'Pago solo por lo que utilizas',
        'Ideal para tráfico estacional'
      ],
      ctaText: 'Más información'
    },
    {
      icon: 'bi bi-stars',
      title: 'Modelo Freemium',
      description: 'Accede a funcionalidades básicas sin costo y actualiza a un plan de pago cuando necesites más capacidades.',
      features: [
        '100 interacciones/mes gratis',
        'Canal web incluido',
        'Actualización flexible a planes premium'
      ],
      ctaText: 'Comenzar gratis'
    },
    {
      icon: 'bi bi-graph-up-arrow',
      title: 'Precios Basados en Resultados',
      description: 'Paga según el valor generado, como la cantidad de leads calificados obtenidos a través del agente.',
      features: [
        'Pago por lead generado',
        'Métricas personalizadas de éxito',
        'Ideal para equipos de ventas y marketing'
      ],
      ctaText: 'Contactar ventas'
    }
  ];
  
  requestInfo(modelTitle: string): void {
    // Aquí puedes implementar la lógica para manejar los clics en los botones CTA
    console.log(`Solicitud de información para el modelo: ${modelTitle}`);
    // Por ejemplo, abrir un modal, navegar a otra página, etc.
  }
}